import {
  LOAD_SETTINGS_REQUEST,
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_FAILURE,
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAILURE,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAILURE,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAILURE,
  UPDATE_EMAIL_REQUEST,
  UPDATE_EMAIL_SUCCESS,
  UPDATE_EMAIL_FAILURE,
  INVITE_USER_REQUEST,
  INVITE_USER_SUCCESS,
  INVITE_USER_FAILURE,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  UPDATE_NAME_REQUEST,
  UPDATE_NAME_SUCCESS,
  UPDATE_NAME_FAILURE,
  UPDATE_USER_ROLE_REQUEST,
  UPDATE_USER_ROLE_SUCCESS,
  UPDATE_USER_ROLE_FAILURE,
  UPDATE_USER_DEPARTMENT_REQUEST,
  UPDATE_USER_DEPARTMENT_SUCCESS,
  UPDATE_USER_DEPARTMENT_FAILURE,
  DELETE_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAILURE,
  PUBLISH_AGREEMENT_REQUEST,
  PUBLISH_AGREEMENT_SUCCESS,
  PUBLISH_AGREEMENT_FAILURE,
  UPDATE_LEVER_USER_REQUEST,
  UPDATE_LEVER_USER_SUCCESS,
  UPDATE_LEVER_USER_FAILURE,
  CREATE_TT_USER_REQUEST,
  CREATE_TT_USER_SUCCESS,
  CREATE_TT_USER_FAILURE,
  RESET_UPDATED_IDS,
} from './constants';
import { logError } from 'global/errors';
import services from 'api/services';
const { CompanyService, DepartmentService, EmailService, AccountService, GDPRAgreementService } = services;

export const loadSettings = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_SETTINGS_REQUEST });
    const companySettings = await CompanyService.loadCompanySettings();
    dispatch({ type: LOAD_SETTINGS_SUCCESS, data: companySettings });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_SETTINGS_FAILURE, error: ex.message });
  }
};

export const loadDepartmentSettings = (id) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_SETTINGS_REQUEST });
    const companySettings = await DepartmentService.getDepartment(id);
    dispatch({ type: LOAD_SETTINGS_SUCCESS, data: companySettings });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_SETTINGS_FAILURE, error: ex.message });
  }
};

export const updateCompany = (companyId, body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_COMPANY_REQUEST });
    const company = await CompanyService.updateCompany(companyId, body);
    dispatch({ type: UPDATE_COMPANY_SUCCESS, data: company });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_COMPANY_FAILURE, error: ex.message });
  }
};

export const updateDepartment = (departmentId, body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_DEPARTMENT_REQUEST });
    const department = await DepartmentService.updateDepartment(departmentId, body);
    dispatch({ type: UPDATE_DEPARTMENT_SUCCESS, data: department });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_DEPARTMENT_FAILURE, error: ex.message });
  }
};

export const createDepartment = (body) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_DEPARTMENT_REQUEST });
    const department = await DepartmentService.createDepartment(body);
    dispatch({ type: CREATE_DEPARTMENT_SUCCESS, data: department });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_DEPARTMENT_FAILURE, error: ex.message });
  }
};

export const updateEmail = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EMAIL_REQUEST });
    const isUpdated = await EmailService.updateEmail(body);
    dispatch({ type: UPDATE_EMAIL_SUCCESS, data: isUpdated });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_EMAIL_FAILURE, error: ex.message });
  }
};

export const inviteUser = (body) => async (dispatch) => {
  try {
    dispatch({ type: INVITE_USER_REQUEST });
    const user = await AccountService.inviteUser(body);
    dispatch({ type: INVITE_USER_SUCCESS, data: user });
  } catch (ex) {
    logError(ex);
    dispatch({ type: INVITE_USER_FAILURE, error: ex.message });
  }
};

export const deleteAccount = (userId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ACCOUNT_REQUEST });
    const isDeleted = await AccountService.deleteAccount(userId);
    dispatch({ type: DELETE_ACCOUNT_SUCCESS, data: isDeleted ? userId : false });
  } catch (ex) {
    logError(ex);
    dispatch({ type: DELETE_ACCOUNT_FAILURE, error: ex.message });
  }
};

export const updateName = (userId, body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_NAME_REQUEST });
    const user = await AccountService.updateName(userId, body);
    dispatch({ type: UPDATE_NAME_SUCCESS, data: user });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_NAME_FAILURE, error: ex.message });
  }
};

export const updateUserRole = (userId, role) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_ROLE_REQUEST });
    const user = await AccountService.updateUserRole(userId, role);
    dispatch({ type: UPDATE_USER_ROLE_SUCCESS, data: user });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_USER_ROLE_FAILURE, error: ex.message });
  }
};

export const updateUserDepartment = (userId, departmentId) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_DEPARTMENT_REQUEST });
    const user = await AccountService.updateUserDepartment(userId, departmentId);
    dispatch({ type: UPDATE_USER_DEPARTMENT_SUCCESS, data: user });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_USER_DEPARTMENT_FAILURE, error: ex.message });
  }
};

export const deleteDepartment = (departmentId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_DEPARTMENT_REQUEST });
    const isDeleted = await DepartmentService.deleteDepartment(departmentId);
    dispatch({ type: DELETE_DEPARTMENT_SUCCESS, data: isDeleted });
  } catch (ex) {
    logError(ex);
    dispatch({ type: DELETE_DEPARTMENT_FAILURE, error: ex.message });
  }
};

export const publishAgreement = (companyId, body) => async (dispatch) => {
  try {
    dispatch({ type: PUBLISH_AGREEMENT_REQUEST });
    const agreement = await GDPRAgreementService.publishAgreement(companyId, body);
    dispatch({ type: PUBLISH_AGREEMENT_SUCCESS, data: agreement });
  } catch (ex) {
    logError(ex);
    dispatch({ type: PUBLISH_AGREEMENT_FAILURE, error: ex.message });
  }
};

export const updateLeverIntegrationUser = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_LEVER_USER_REQUEST });
    const user = await AccountService.updateLeverIntegrationUser(body);
    dispatch({ type: UPDATE_LEVER_USER_SUCCESS, data: user });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_LEVER_USER_FAILURE, error: ex.message });
  }
};

export const createTeamTailorIntegrationUser = (body) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_TT_USER_REQUEST });
    const user = await AccountService.createTeamTailorIntegrationUser(body);
    dispatch({ type: CREATE_TT_USER_SUCCESS, data: user });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_TT_USER_FAILURE, error: ex.message });
  }
};

export const resetUpdatedIds = () => async (dispatch) => {
  dispatch({ type: RESET_UPDATED_IDS });
};
